import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

export interface NotificationPanelOpenOptions {
  modoOscuro: boolean;
  /** Botón u otro elemento del header para colocar el panel debajo (p. ej. campana). */
  anchor?: HTMLElement | null;
}

/**
 * Registrado en la app shell: abre el panel (MatDialog posicionado) sin importar UI desde la librería `layout`
 * (evita TS6059 por `rootDir` de layout).
 */
export const NOTIFICATION_PANEL_OPENER = new InjectionToken<
  (opts: NotificationPanelOpenOptions) => Observable<unknown>
>('NOTIFICATION_PANEL_OPENER');
